<script lang="ts">
  import {currentFrame, TimestampText} from '@/store/recap';
  import {onDestroy, onMount} from 'svelte';
  import {fps} from '../Util';

  export let sentence: {texts: {text: string; start: number}[]; start: number; end: number};

  let elementRef: HTMLDivElement;

  const framesNeededToTransitionInMS = Math.round(fps * 0.18);

  let fontSize: string = '';
  let frame = 0;

  const frameSubscription = currentFrame.subscribe(value => (frame = value));

  onMount(() => {
    if (!elementRef) return console.error('element null');
    if (!elementRef.parentElement) return console.error('Parent element null');

    elementRef.style.fontSize = `${elementRef.parentElement.clientHeight}px`;
    // dynamicFontSize(elementRef.parentElement, elementRef);

    fontSize = elementRef.style.fontSize;
  });

  onDestroy(() => {
    frameSubscription();
  });

  function interpolate(currentFrame: number, array: number[], valueArray: number[]) {
    const [startFrame, endFrame] = array;
    const [startValue, endValue] = valueArray;
    const lengthValue = endValue - startValue;
    return currentFrame < startFrame
      ? startValue
      : currentFrame > endFrame
        ? endValue
        : startFrame + lengthValue * (currentFrame / endFrame);
  }

  function dynamicFontSize(parentElement: HTMLElement, element: HTMLElement) {
    if (parentElement.clientHeight >= element.clientHeight) return;

    const fontSize = parseFloat(window.getComputedStyle(element).fontSize.split('px')[0]);
    const newFontSize = (isNaN(fontSize) ? 40 : fontSize) - 0.1;
    if (newFontSize <= 0) {
      element.style.fontSize = `8px`;
      return;
    }

    element.style.fontSize = `${newFontSize}px`;

    dynamicFontSize(parentElement, element);
  }

  $: {
    const frameBefore = frame - 10;
    if (frameBefore >= sentence.start && frameBefore <= sentence.end && elementRef && elementRef.parentElement) {
      // console.log("VISIBLE", sentence.texts);
      dynamicFontSize(elementRef.parentElement, elementRef);
    }
  }
</script>

<div
  bind:this={elementRef}
  class="absolute flex flex-wrap justify-center gap-[1rem]"
  style={`font-size: ${fontSize}; opacity: ${frame > sentence.end ? 0 : interpolate(frame, [sentence.start, sentence.start + framesNeededToTransitionInMS], [0, 1])}; font-family: inherit;`}
>
  {#each sentence.texts as item}
    <span
      style={`opacity: ${interpolate(frame, [item.start, item.start + framesNeededToTransitionInMS], [0, 1])}; font-family: inherit;`}
      >{item.text}</span
    >
  {/each}
</div>
